<template>
	<setting-input
		:can-edit="!!(roles.usr && roles.usr.info && roles.usr.info.delete)"
		:on-commit="closeAccount"
		:class="'no-input'"
		:on-reset="resetState"
		:hide-commit="true"
		:require-password="true"
		:label="'Close my account'"
		:input-ref="'close'"
		:button-text="'Close Account'"
		:status="userStatusDelete">
		<!-- updating slot -->
		<spinner slot="updating-inline" :text="'Processing'" v-if="userStatusDelete.loading"></spinner>
		<!-- info slot -->
		<blockquote v-if="$root.isTek" slot="info-block" class="notice error">
			<b>Important:</b>
			Once your account is closed, you won't be able to access TekCloud and all associated data will be lost.
			<p>If you are certain you want to proceed, provide your account password and press "Apply".</p>
		</blockquote>
		<blockquote v-else slot="info-block" class="notice error">
			<b>Important:</b>
			This account will be closed and all associated data will be lost.
			<span class="is-support">Consequently, this app will feel somehow less whole, unable to recall all the good times it shared with this account.</span>
			<p>If you are certain you want to proceed, provide your account password and press "Apply".</p>
		</blockquote>
	</setting-input>
</template>

<script>
import SettingInput from '../components/SettingInput';
import Spinner from '@/components/Spinner';
import Collapsible from '../components/Collapsible';
import { mapGetters } from 'vuex';
export default {
	name: 'CloseAccount',
	data() {
		return {
			newPassword: '',
			email: '',
			newEmail: '',
			enableFn: null
		};
	},
	computed: {
		...mapGetters([
			'user',
			'roles',
			'userStatus',
			'userStatusDelete',
			'accountStatus'
		])
	},
	components: {
		SettingInput,
		Spinner,
		Collapsible,
	},
	methods: {
		closeAccount(password) {
			if (!password) {
				return;
			}
			const vm = this;
			return new Promise((resolve, reject) => {
				this.$store.dispatch('DELETE_REQUEST', { password: password })
					.then(response => {
						vm.$router.push({path: '/logout', query: { reason: 'closed' }});
					})
					.catch(reason => {
						reject(reason);
					});
			});
		},
		resetState() {
			this.$store.dispatch('RESET_USER_STATUS');
		}
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.tfa-code {
		width: 75px;
	}
	.notice.error.center::before,
	.notice.error.center::after {
	    left: 50%;
	    margin-left: -14px;
	}
	.blockquote .info.notice {
		/* margin-bottom: 1em; */
	}
	img {
		border: 1px solid #eee;
		margin-top: 1em;
		border-radius: 3px;
		width: max-content;
	}

</style>



// WEBPACK FOOTER //
// ./src/views/CloseAccount.partial.vue